import React, { forwardRef } from 'react';
import { t } from '@lingui/macro';
import { Box } from '@landr/maestro';
import { Pack, Repack } from 'types/generated/graphql';
import Card from 'components/Card/Card';
import PreviewActions from 'components/Carousels/components/PreviewActions';

interface PackPreviewCardProps {
    isExclusive?: boolean;
    backgroundColor?: string;
    linkTo?: string;
    bylineLinkTo?: string;
    artworkUrl?: string;
    item?: Pack | Repack;
    title?: string;
    byline?: string;
    isLoading?: boolean;
    isTakenDownUIVisible?: boolean;
    onLinkClick?: React.MouseEventHandler<HTMLDivElement>;
    isHovered?: boolean;
}

export const PackPreviewCard = forwardRef<
    HTMLDivElement,
    PackPreviewCardProps & React.RefAttributes<HTMLDivElement>
>(
    (
        {
            isExclusive = false,
            backgroundColor,
            linkTo,
            bylineLinkTo,
            artworkUrl,
            item,
            title,
            byline,
            isLoading = false,
            onLinkClick,
            isHovered = false,
            isTakenDownUIVisible = false,
        },
        ref,
    ) => (
        <Box as="span" data-testid="pack-preview-card">
            <Card
                ref={ref}
                isExclusive={isExclusive}
                backgroundColor={backgroundColor}
                linkTo={linkTo}
                bylineLinkTo={bylineLinkTo}
                isLoading={isLoading}
                onLinkClick={onLinkClick}
            >
                <Card.BackgroundImage
                    imageUrl={artworkUrl}
                    fallbackSrc={`${
                        import.meta.env.BASE_URL
                    }assets/fallback/artworkPlaceholder.svg`}
                    imageSize="default"
                    alt={item?.name ? t`Artwork of ${item?.name}` : ''}
                />
                {item && (
                    <Card.Actions centeredActions={true}>
                        <PreviewActions
                            item={item}
                            isHovered={isHovered}
                            isTakenDownUIVisible={isTakenDownUIVisible}
                        />
                    </Card.Actions>
                )}

                <Card.Title>{title}</Card.Title>
                <Card.Byline>{byline}</Card.Byline>
            </Card>
        </Box>
    ),
);

PackPreviewCard.displayName = 'PackPreviewCard';

export default PackPreviewCard;
